import { StyleSheet } from '@react-pdf/renderer';

import { theme } from '../../../../theme';

const { main: pdfPrimaryMain, pastelBlue: pdfPrimaryPastelBlue } = theme.palette.primary;

export default StyleSheet.create({
  page: {
    padding: 36,
    fontSize: 10,
    color: pdfPrimaryMain,
  },
  title: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 12,
    borderBottomWidth: 1,
    borderBottomColor: pdfPrimaryPastelBlue,
    paddingBottom: 8,
  },
  metaRow: {
    flexDirection: 'row',
    marginBottom: 4,
  },
  metaLabel: {
    width: 90,
    fontWeight: 'bold',
    fontSize: 10,
  },
  metaValue: {
    flex: 1,
    fontSize: 10,
  },
  sectionTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    marginTop: 16,
    marginBottom: 8,
  },
  qaBlock: {
    marginBottom: 10,
    borderBottomWidth: 0.5,
    borderBottomColor: '#e0e0e0',
    paddingBottom: 8,
  },
  question: {
    fontSize: 10,
    fontWeight: 'bold',
    marginBottom: 4,
  },
  answer: {
    fontSize: 10,
    lineHeight: 1.4,
  },
  signatureImage: {
    marginTop: 4,
    maxHeight: 100,
    maxWidth: 280,
    objectFit: 'contain',
  },
});
